// import React from "react";
// import "./footer.css";
// import brandLogo from "../assets/logo.png";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faFacebookF,
//   faInstagram,
//   faYoutube,
// } from "@fortawesome/free-brands-svg-icons";

// const Footer = () => {
//   return (
//     <footer className="footer-section">
//       <div className="footer-inner">
//         {/* -------- Top area -------- */}
//         <div className="footer-top">
//           {/* Left: tagline + logo */}
//           <div className="footer-left">
//             <p className="footer-tagline">
//               Get better results while saving time.
//               <br />
//               Trusted by 10,000+ advertisers in the world.
//             </p>

//             <div className="footer-brand">
//               <img
//                 src={brandLogo}
//                 alt="Shubha Graphics logo"
//                 className="footer-logo"
//               />
//             </div>
//           </div>

//           {/* Right: link columns */}
//           <div className="footer-links">
//             <div className="footer-column">
//               <h4 className="footer-column-title">ABOUT</h4>
//               <a href="#mission" className="footer-link">
//                 Mission
//               </a>
//               <a href="#news" className="footer-link">
//                 News
//               </a>
//               <a href="#team" className="footer-link">
//                 Our Team
//               </a>
//             </div>

//             <div className="footer-column footer-column-social">
//               <h4 className="footer-column-title">FOLLOW US</h4>
//               <div className="footer-social-icons">
//                 <a
//                   href="#facebook"
//                   className="social-icon"
//                   aria-label="Facebook"
//                 >
//                   <FontAwesomeIcon icon={faFacebookF} />
//                 </a>
//                 <a
//                   href="#instagram"
//                   className="social-icon"
//                   aria-label="Instagram"
//                 >
//                   <FontAwesomeIcon icon={faInstagram} />
//                 </a>
//                 <a href="#youtube" className="social-icon" aria-label="YouTube">
//                   <FontAwesomeIcon icon={faYoutube} />
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* -------- Bottom area -------- */}
//         <div className="footer-bottom">
//           <div className="footer-bottom-left">
//             © 2026 All Rights Reserved. Shubha Graphics
//           </div>

//           <div className="footer-bottom-center">
//             <span>Made with</span>
//             <span className="footer-heart" role="img" aria-label="love">
//               ❤️
//             </span>
//             <a
//               href="https://tech.rosettesmartlife.com"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="footer-bottom-link"
//             >
//               Rosette Technologies
//             </a>
//           </div>
//           <div className="footer-bottom-right">
//             <a href="#privacy" className="footer-bottom-link">
//               Privacy Policy
//             </a>
//             <span className="footer-dot">•</span>
//             <a href="#terms" className="footer-bottom-link">
//               Terms &amp; Conditions
//             </a>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;


import React from "react";
import "./footer.css";
import brandLogo from "../assets/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FiPhoneCall} from "react-icons/fi";
import {
  faFacebookF,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-inner">
        {/* -------- Top area -------- */}
        <div className="footer-top">
          {/* Left: tagline + logo + phone numbers */}
          <div className="footer-left">
            <p className="footer-tagline">
              Get better results while saving time.
              <br />
              Trusted by 10,000+ advertisers in the world.
            </p>

            <div className="footer-brand">
              <img
                src={brandLogo}
                alt="Shubha Graphics logo"
                className="footer-logo"
              />
            </div>

            {/* Contact numbers under the logo */}
            <div className="footer-contact">
              <FiPhoneCall className="header-pill__icon" />
              <a
                href="tel:+919483838409"
                className="footer-contact-number"
                aria-label="Call Shubha Graphics: 9483838409"
              >
                9483838409
              </a>
              <span className="footer-contact-separator">, </span>
              <a
                href="tel:+918861079975"
                className="footer-contact-number"
                aria-label="Call Shubha Graphics: 8861079975"
              >
                8861079975
              </a>
            </div>
          </div>

          {/* Right: link columns */}
          <div className="footer-links">
            <div className="footer-column">
              <h4 className="footer-column-title">ABOUT</h4>
              <a href="#mission" className="footer-link">
                Mission
              </a>
              <a href="#news" className="footer-link">
                News
              </a>
              <a href="#team" className="footer-link">
                Our Team
              </a>
            </div>

            <div className="footer-column footer-column-social">
              <h4 className="footer-column-title">FOLLOW US</h4>
              <div className="footer-social-icons">
                <a
                  href="#facebook"
                  className="social-icon"
                  aria-label="Facebook"
                >
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
                <a
                  href="#instagram"
                  className="social-icon"
                  aria-label="Instagram"
                >
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a href="#youtube" className="social-icon" aria-label="YouTube">
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* -------- Bottom area -------- */}
        <div className="footer-bottom">
          <div className="footer-bottom-left">
            © 2026 All Rights Reserved. Shubha Graphics
          </div>

          <div className="footer-bottom-center">
            <span>Made with</span>
            <span className="footer-heart" role="img" aria-label="love">
              ❤️
            </span>
            <a
              href="https://tech.rosettesmartlife.com"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-bottom-link"
            >
              Rosette Technologies
            </a>
          </div>
          <div className="footer-bottom-right">
            <a href="#privacy" className="footer-bottom-link">
              Privacy Policy
            </a>
            <span className="footer-dot">•</span>
            <a href="#terms" className="footer-bottom-link">
              Terms &amp; Conditions
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;